module.exports = __webpack_public_path__ + "img/event3.772da02a.png";